import { Link, useSearchParams } from "react-router-dom"
import HomeSearch from "../components/elements/HomeSearch"
import MobileHeaderSearch from "../components/MobileHeaderSearch"
import useWidth from "../hooks/useWidth"
import MobileHeader from "../layout/MobileHeader"
import Navbar from "../layout/Navbar"
import { useFetch } from "../hooks/useFetch"
import { homeSearch } from "../apis"
import { useState } from "react"
import BlogCard from "../components/cards/BlogCard"
import GuideCardMobile from "../components/cards/mobileView/GuideCard"
import GuideCard from "../components/cards/GuideCard"


export default () => {
    const width = useWidth()
    const searchParams = useSearchParams()
    const tag = searchParams[0].get("tag");
    const search = searchParams[0].get("search");

    const [filters,] = useState({ tag, search })
    const searchData = useFetch(homeSearch, {}, filters)

    return (
        <>
            {
                width > 992 ?
                    <Navbar gradient />
                    :
                    <MobileHeader>
                        <MobileHeaderSearch placeholder="Search Tour& Events" />
                    </MobileHeader>
            }

            {width > 992 && <section>
                <div className="desktop-top-space pb-3">
                    <div className="d-flex justify-content-center flex-column align-items-center ">
                        <h1 className="custom-heading xx-bold">Search Result</h1>
                        <HomeSearch placeholder={"Search Hotels"} />
                    </div>
                </div>
            </section>}

            <section className="mobile-top-space desktop-top-space">
                {searchData?.guides?.length > 0 && <section>
                    <div className="mt-4 ">
                        <div className="d-flex justify-content-between px-4">
                            <div className="top-heading">Guides</div>
                            <Link to={'/guide'} className="view-all" style={{ width: "auto" }}>
                                Explore more
                            </Link>
                        </div>

                        {/* Guides  cards */}
                        <div className="mt-4">
                            <ul className="list-unstyled guide-Mobile-List d-flex overflow-auto scrollbar-hidden ">
                                {searchData?.guides?.map((guide, i) => (
                                    <li key={i} className="p-2">
                                        {width > 768 ? <GuideCard data={guide} /> : <GuideCardMobile data={guide} />}
                                    </li>
                                ))}
                            </ul>
                            <Link to={'/guide'} className="d-flex justify-content-center d-lg-none mb-5">
                                <button className="secondary-btn ">Explore More</button>
                            </Link>
                        </div>
                    </div>
                </section>}


                {searchData?.blogs?.length > 0 && <section>
                    <div className="d-flex justify-content-between p-4">
                        <div className="">
                            <div className="top-heading">Blogs</div>
                            <div className="top-destinations-subHeading mt-2">
                                Making the Most of Your Travel Experience in 2024
                            </div>
                        </div>
                        <div className="">
                            <Link to={'/blogs'} className="view-all">View All</Link>
                        </div>
                    </div>

                    <div className=" p-lg-4">
                        <div className="d-flex overflow-auto scrollbar-hidden p-0 ">
                            {searchData.blogs?.map((blog, i) => (
                                <div key={i} className="col-md-6 col-lg-3 ">
                                    <div className="m-2">
                                        <BlogCard data={blog} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>}
            </section>

        </>
    )
}